export function LocationIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.00008 8.00016C10.2887 8.00016 11.3334 6.95549 11.3334 5.66683C11.3334 4.37817 10.2887 3.3335 9.00008 3.3335C7.71142 3.3335 6.66675 4.37817 6.66675 5.66683C6.66675 6.95549 7.71142 8.00016 9.00008 8.00016Z"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.00005 1.3335C11.5241 1.33386 13.5701 3.38011 13.5701 5.90416C13.5701 8.0475 10.2754 13.3608 9.28072 14.9155C9.21943 15.0111 9.11365 15.069 9.00005 15.069C8.88645 15.069 8.78067 15.0111 8.71939 14.9155C7.72472 13.3608 4.43005 8.04883 4.43005 5.90416C4.42988 4.69201 4.91128 3.52944 5.76834 2.67225C6.6254 1.81507 7.7879 1.3335 9.00005 1.3335V1.3335Z"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.3334 14.1333C14.8987 14.3493 16.6667 14.806 16.6667 15.3333C16.6667 16.07 13.2347 16.6666 9.00004 16.6666C4.76537 16.6666 1.33337 16.07 1.33337 15.3333C1.33337 14.8066 3.09004 14.3513 5.63871 14.1333"
                stroke="#A5AAAF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
